/* eslint-disable react/no-unused-prop-types */
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

interface Props {
  data: any
  height: number
  isPositive: boolean
  width: number | null
}
const getOptions = ({ data, height, isPositive, width }: Props) => ({
  chart: {
    type: 'line',
    backgroundColor: 'none',
    borderColor: 'none',
    borderWidth: 0,
    width,
    height,
    spacing: [0, 0, 0, 0]
  },
  legend: {
    enabled: false
  },
  title: {
    text: ''
  },
  xAxis: {
    visible: false
  },
  yAxis: {
    visible: false
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    line: {
      enableMouseTracking: false
    }
  },
  series: [
    {
      color: isPositive ? '#3BB719' : '#f60e08',
      data,
      animation: false
    }
  ]
})

export const UnlabelledLineChart = (props: Props) => (
  <HighchartsReact highcharts={Highcharts} options={getOptions(props)} />
)
